"use client";

import React from "react";
import { Quote, CircleCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Marc-André L.",
  quote: "Après deux refus bancaires, Jenny a trouvé une solution en 48h. Son expertise en dossiers complexes est inégalée.",
  position: "Travailleur autonome"
}, {
  id: 2,
  author: "Sophie R.",
  quote: "Un accompagnement humain et ultra-professionnel pour mon sauvetage immobilier. Elle a sauvé ma maison.",
  position: "Propriétaire"
}, {
  id: 3,
  author: "Jean-François T.",
  quote: "La rapidité d'exécution et la clarté des conseils m'ont permis de consolider mes dettes sans stress.",
  position: "Client Refinancement"
}];
export default function HistoiresDeSuccS() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222594" id="histoires-de-succès" className="w-full py-24 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out flex flex-col items-center ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16 max-w-2xl mx-auto">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-primary mb-4">
              Histoires de Succès
            </h2>
            <p className="text-muted-foreground text-lg font-default">
              Découvrez comment nous transformons les situations complexes en approbations hypothécaires.
            </p>
          </div>

          <div className="w-full max-w-5xl mx-auto relative">
            {}
            <div className="absolute inset-0 bg-muted rounded-md -z-10 transform -rotate-1 scale-105 transition-transform duration-500 hover:rotate-0 border border-border" />
            
            <div className="bg-card rounded-md p-8 md:p-16 lg:p-20 relative shadow-lg border border-border/50">
              <Quote className="absolute top-8 left-8 md:top-12 md:left-12 size-16 md:size-24 text-secondary/20 -z-0" />
              
              <Carousel opts={{
              align: "start",
              loop: true
            }} className="w-full relative z-10">
                <CarouselContent>
                  {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                      <div className="flex flex-col items-center text-center space-y-8 md:space-y-12">
                        <blockquote className="max-w-3xl">
                          <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-relaxed text-foreground/90">
                            "{testimonial.quote}"
                          </p>
                        </blockquote>
                        
                        <div className="flex flex-col items-center space-y-4">
                          <div className="space-y-1">
                            <h3 className="font-default text-xl font-semibold text-primary">
                              {testimonial.author}
                            </h3>
                            <p className="text-muted-foreground text-sm font-default">
                              {testimonial.position}
                            </p>
                          </div>
                          
                          <Badge variant="secondary" className="bg-secondary/10 backdrop-blur-sm border-secondary/30 text-primary font-default gap-1.5 py-1 px-3 rounded-md">
                            <CircleCheck className="size-3.5" />
                            Dossier Approuvé
                          </Badge>
                        </div>
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                
                <div className="hidden md:block">
                  <CarouselPrevious className="bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-primary transition-colors rounded-md" />
                  <CarouselNext className="bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-primary transition-colors rounded-md" />
                </div>
                
                {}
                <div className="flex justify-center gap-2 mt-8 md:hidden">
                  <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-primary rounded-md" />
                  <CarouselNext className="static translate-y-0 translate-x-0 bg-background/80 hover:bg-primary hover:text-primary-foreground border-border text-primary rounded-md" />
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>;
}